// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1179":"34e0b8e327f70875","4439":"b37699647eab6bfc","5801":"8ca8fa7882a05e8b","7744":"65a23e53adfc4596","7746":"9e126b9276a52dfb","9591":"507a520c1e0c02c1","9860":"2971d31caef6b4df"}[chunkId] + ".1779881240531.js";
};